import keyMirror from 'keymirror';

const headerPageBoxTypes = keyMirror({
  trimmedTop: null,
  lifted: null,
});

export default headerPageBoxTypes;
